<template>
    <div class="app flex-row align-items-center" style="background-color: #0856ab;">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="4">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <b-form>
                                    <div class="text-center">
                                        <img src="/img/logo.png" style="width: 150px;">
                                    </div>
                                    <h1 class="text-center">Login</h1>
                                    <p class="text-muted text-center">
                                        Sign In to your account
                                    </p>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-user"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="text"
                                            class="form-control"
                                            placeholder="Email"
                                            v-model="model.username"
                                            @keypress.enter="emailPressHandler"
                                        />
                                    </b-input-group>
                                    <b-input-group class="mb-4">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-lock"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input
                                            type="password"
                                            class="form-control"
                                            placeholder="Password"
                                            v-model="model.password"
                                            ref="password"
                                            @keypress.enter="onLogin"
                                        />
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-button
                                                variant="primary"
                                                class="btn-block"
                                                @click="onLogin"
                                                >Login</b-button
                                            >
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import base from '../shared/models/coreapi';
export default {
    name: "Login",
    data: function () {
        return {
            model: {
                granttype: "password",
                username: "",
                password: "",
            },
            logo: this.$base() + 'image/logo'
        };
    },
    created: function () {
        localStorage.removeItem("jwt");
        localStorage.removeItem("jwt@exp");
    },
    methods: {
        onLogin () {
            let loading = this.$loading.show();
            axios({
                method: "POST",
                url: this.$base() + "account/login",
                data: this.model
            }).then(res => {
                if (res.status == 200) {
                    if(res.data.IsError){
                        this.$swal.fire('Warning message', res.data.Message, "warning");
                    }else {
                        const data = res.data.Json;
                        base.setToken(data.Token);
                        this.$store.commit('updateAuthInfo', data.Auth);
                        this.$store.commit('updateCompany', data.Companies);
                        this.$i18n.locale = this.$store.state.auth.Language;
                        this.$router.push({ name: '1000-01'});
                    }
                }
            }).catch(err =>{
                this.$swal.fire("Message", err.toString(), "warning");
            }).finally(function () { loading.hide();});
        },
        emailPressHandler: function () {
            this.$refs.password.focus();
        },
    },
};
</script>
<style>
.card-group > .card {
    border: none;
    box-shadow: none;
    border-radius: 3px;
}
</style>
